import React from 'react'

export const IconDown = (props={}) => {
	const { size=20, imgSize=20 } = props
	return <>
		<svg width={`${size}px`} height={`${size}px`} viewBox={`0 0 ${imgSize} ${imgSize}`} stroke="currentColor" fill="currentColor" strokeWidth="0" xmlns="http://www.w3.org/2000/svg">
			<path d="M16.995 7.75245L9.74751 15L2.5 7.75245L3.38334 6.86829L9.74751 13.2325L16.1116 6.86829L16.995 7.75245Z" />
		</svg>
	</>
}
